module.exports = __webpack_public_path__ + "static/sound-thumbnail-f754aec3f0c710773a7c2da468bf08a2.png";